export default __webpack_public_path__ + "static/media/lu.8c67c6a8.svg";